var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4183 3.48993C11.9422 3.402 11.505 3.70579 11.4144 4.17047C11.3238 4.63515 11.6285 5.08884 12.0916 5.17977C13.4859 5.45159 14.5624 6.53085 14.8353 7.92989V7.93088C14.913 8.33361 15.2675 8.62641 15.6759 8.62641C15.7306 8.62641 15.7854 8.62141 15.8412 8.61142C16.3043 8.51848 16.609 8.06579 16.5184 7.60011C16.1111 5.51055 14.5027 3.89666 12.4183 3.48993Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3558 0.00792976C12.1328 -0.0240483 11.9087 0.0419064 11.7304 0.183809C11.5472 0.32771 11.4326 0.535567 11.4078 0.768408C11.355 1.23908 11.6946 1.66479 12.1646 1.71776C15.4063 2.07951 17.9259 4.60477 18.2904 7.85654C18.3392 8.29224 18.7047 8.62101 19.1409 8.62101C19.1738 8.62101 19.2057 8.61902 19.2385 8.61502C19.4666 8.59004 19.6698 8.47711 19.8132 8.29724C19.9556 8.11736 20.0203 7.89351 19.9944 7.66467C19.5403 3.60746 16.4002 0.45862 12.3558 0.00792976Z",
    fill: "#495057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03174 10.9724C13.0208 14.9604 13.9258 10.3467 16.4656 12.8848C18.9143 15.3328 20.3216 15.8232 17.2192 18.9247C16.8306 19.237 14.3616 22.9943 5.6846 14.3197C-2.99348 5.644 0.761585 3.17244 1.07397 2.78395C4.18387 -0.326154 4.66586 1.08938 7.11449 3.53733C9.65436 6.0765 5.04266 6.98441 9.03174 10.9724Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.82bbf9155db77169eea9b7aadd2dab28.svg";
export { ForwardRef as ReactComponent };